import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TourType } from '../../data/tour-config';
import { tourProgressFeatureKey, TourProgressState } from '../reducer/tour-progress.reducer';

const selectTourProgressFeatureUnsafe = createFeatureSelector<TourProgressState | undefined>(tourProgressFeatureKey);

export const selectTourProgressFeature = createSelector(
  selectTourProgressFeatureUnsafe,
  state => state ?? { progress: [], isLoaded: false, pendingRollback: {} }
);

export const selectTourProgress = createSelector(selectTourProgressFeature, state => state.progress);

export const selectIsTourProgressLoaded = createSelector(selectTourProgressFeature, state => state.isLoaded);

export const selectSeenVersion = (tourType: TourType) =>
  createSelector(selectTourProgress, progress => progress.find(p => p.tourTypeId === tourType)?.seenVersion ?? 0);
